import { Box, Stack, TextareaAutosize } from "@mui/material";
import QRcodeTriggers from "assets/images/tca/4/QRcodeFU04ExerciseTriggers.png";
import QRcodeSelfRewards from "assets/images/tca/4/QRcodeFU04SelfRewards.png";
import { useRef } from "react";
import { Controller, useFormContext } from "react-hook-form";
import ReactToPrint from "react-to-print";

import VideoBlock from "../VideoBlock";
import YmcaPageHeader from "../YmcaPageHeader";

const StageFollowup04 = ({ sendContractToBackend }) => {
  const formContext = useFormContext();
  const { control, watch } = formContext;
  const watchFieldsToPrint = watch(["smsFollowUp04.triggers", "smsFollowUp04.rewards"]);
  const printTemplateRef = useRef();

  return (
    <>
      <Box className="greenContainer">
        <Box className="containerPadding">
          <Stack>
            <Box className="header1" mb={"20px"}>
              Follow Up Appointment 4
            </Box>
            <Box className="header2 green" mb={"16px"}>
              EXERCISE TRIGGERS & SELF REWARDS
            </Box>
          </Stack>
          <VideoBlock
            thumbnail="https://img.youtube.com/vi/cBhp2Rs2nxw/maxresdefault.jpg"
            youtubeLink={
              "https://www.youtube.com/watch?v=cBhp2Rs2nxw&list=PLgBxj8BHl0M33FtRIckAJCR0JEjqz2ujJ&index=4"
            }
          >
            <>
              <Box className="text text-bold video-title" mt={0.75} mb={2}>
                Watch these videos to get started!
              </Box>
            </>
          </VideoBlock>
          <Box className="text text-bold" mb={2.5}>
            Exercise Triggers
          </Box>
          <Box className="text" mb={2.5}>
            <p>
              Exercise triggers are behaviors or actions that trigger you to exercise. That could be
              making a group ex class reservation or laying out your workout clothes for the next
              day at night before you go to bed.
            </p>
          </Box>
          <Box className="text text-bold" mb={2.5}>
            <p className="">
              What are a few things that trigger you to exercise? Jot a few of them down below:
            </p>
          </Box>
          <Controller
            name="smsFollowUp04.triggers"
            control={control}
            rules={{ required: false }}
            render={({ field }) => (
              <Stack spacing={1} mt={2} className="note-input-container">
                <TextareaAutosize
                  {...field}
                  aria-label="description textarea"
                  className="note-textarea"
                  placeholder="Please enter"
                />
              </Stack>
            )}
          />
          <Box className="text text-bold" my={2.5}>
            Self Rewards
          </Box>
          <VideoBlock
            thumbnail="https://img.youtube.com/vi/e0UOB47YyG4/maxresdefault.jpg"
            youtubeLink={
              "https://www.youtube.com/watch?v=e0UOB47YyG4&list=PLgBxj8BHl0M33FtRIckAJCR0JEjqz2ujJ&index=8"
            }
          >
            <>
              <Box className="text text-bold video-title" mt={0.75} mb={2}>
                Watch these videos to get started!
              </Box>
              <Box className="text text-bold">
                Setting up rewards for yourself gives you something to work towards and can be very
                motivating! It could be getting yourself that new pair of running shoes after you
                have reached a long or short-term goal, or going out for a fun activity!
              </Box>
            </>
          </VideoBlock>
          <Box className="text text-bold" my={2.5}>
            Think about ways that we can reward ourselves for accomplishing a goal or maybe trying
            something new such as a new exercise class. Write down your self-reward ideas here:
          </Box>
          <Controller
            name="smsFollowUp04.rewards"
            control={control}
            rules={{ required: false }}
            render={({ field }) => (
              <Stack spacing={1} mt={2} className="note-input-container">
                <TextareaAutosize
                  {...field}
                  aria-label="description textarea"
                  className="note-textarea"
                  placeholder="Please enter"
                />
              </Stack>
            )}
          />
        </Box>
        <hr className="containerDivider" />
        <Stack direction={"row"} justifyContent="space-around">
          <button type="button" className="action-button" onClick={() => sendContractToBackend()}>
            Email Document to the Member
          </button>
          <ReactToPrint
            trigger={() => (
              <button type="button" className="action-button">
                Print Document
              </button>
            )}
            content={() => printTemplateRef.current}
          />
        </Stack>
      </Box>
      <div className="out-of-sight">
        <Stack ref={printTemplateRef} className="elementToPrint">
          <YmcaPageHeader />
          <h1 style={{ color: "#00a98f" }}>EXERCISE TRIGGERS & SELF REWARDS</h1>
          <Box my={2}>
            <p>Watch these videos to get started!</p>
          </Box>
          <Stack direction={"row"} gap={2}>
            <img src={QRcodeTriggers} width="114" height="114" />
            <Stack>
              <Box mb={2}>
                <p className="orange text-bold">Exercise Triggers</p>
              </Box>
              <Box mb={2}>
                <p>
                  Exercise triggers are behaviors or actions that trigger you to exercise. That
                  could be making a group ex class reservation or laying out your workout clothes
                  for the next day at night before you go to bed.
                </p>
              </Box>
              <Box mb={2}>
                <p>
                  What are a few things that trigger you to exercise? Jot a few of them down below:
                </p>
              </Box>
            </Stack>
          </Stack>
          <Box
            className="filledFormField p_wrap"
            style={{
              background: "#edf6ff",
              border: "dotted 1px #313a3d",
              padding: "10px",
              whiteSpace: "pre-line",
            }}
          >
            {watchFieldsToPrint[0]}
          </Box>
          <Stack direction={"row"} gap={2} mt={2}>
            <img src={QRcodeSelfRewards} width="114" height="114" />
            <Stack>
              <Box mb={2}>
                <p className="orange text-bold">Self Rewards</p>
              </Box>
              <Box mb={2}>
                <p>
                  Setting up rewards for yourself gives you something to work towards and can be
                  very motivating! It could be getting yourself that new pair of running shoes after
                  you have reached a long or short-term goal, or going out for a fun activity!
                </p>
              </Box>
              <Box mb={2}>
                <p>
                  Think about ways that we can reward ourselves for accomplishing a goal or maybe
                  trying something new such as a new exercise class. Write down your self-reward
                  ideas here:
                </p>
              </Box>
            </Stack>
          </Stack>
          <Box
            className="filledFormField p_wrap"
            style={{
              background: "#edf6ff",
              border: "dotted 1px #313a3d",
              padding: "10px",
              whiteSpace: "pre-line",
            }}
          >
            {watchFieldsToPrint[1]}
          </Box>
        </Stack>
      </div>
    </>
  );
};

export default StageFollowup04;
